import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Truck, Flower2, CreditCard, ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import SEO from '../components/SEO';

const HomePage = () => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);

  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Carrusel de imágenes del hero - Día de la Madre
  const heroImages = [
    'https://customer-assets.emergentagent.com/job_d77f3a6b-9965-447f-a586-d0e19241b16e/artifacts/4tywpdsy_image.png',
    'https://customer-assets.emergentagent.com/job_d77f3a6b-9965-447f-a586-d0e19241b16e/artifacts/l52v1la3_image.png',
    'https://customer-assets.emergentagent.com/job_d77f3a6b-9965-447f-a586-d0e19241b16e/artifacts/4l7qhuor_image.png'
  ];

  // Auto-advance carousel
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [heroImages.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % heroImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + heroImages.length) % heroImages.length);
  };

  const categories = [
    {
      name: 'Arreglos',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/89bfcc7c-a9c8-443f-8fab-f50a81d06500/publicContain',
      path: '/producto/arreglos',
      alt: 'Arreglos florales premium en Arequipa - Flores frescas delivery'
    },
    {
      name: 'Boxes',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/85bbe1af-b296-4087-84a8-81845666be00/publicContain',
      path: '/producto/boxes',
      alt: 'Boxes florales elegantes Arequipa - Cajas de flores premium'
    },
    {
      name: 'Ramos',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/087f35d1-48ca-4540-4281-08990078ee00/public',
      path: '/producto/ramos',
      alt: 'Ramos de flores frescas Arequipa - Rosas, lirios y más'
    },
    {
      name: 'Peluches',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/080fe01b-7b1a-47fc-e3ff-719967432100/publicContain',
      path: '/producto/peluches',
      alt: 'Peluches con flores Arequipa - Regalos tiernos y románticos'
    },
    {
      name: 'Eventos',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/2d4938a6-6347-4c70-6431-f5ef464fb800/publicContain',
      path: '/producto/eventos',
      alt: 'Decoración floral para eventos Arequipa - Bodas y fiestas'
    },
    {
      name: 'Detalles',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/f3a481d2-b9de-472b-98c2-8ba5f68d7200/public',
      path: '/producto/detalles',
      alt: 'Detalles florales especiales Arequipa - Flores para regalar'
    }
  ];

  const occasions = [
    {
      title: 'Amor y Aniversarios',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/5f3f5c35-2c59-465d-4e09-c0cf93eee600/publicContain',
      path: '/ocasion/amor-aniversario',
      alt: 'Rosas rojas para aniversario Arequipa - Flores románticas'
    },
    {
      title: 'Flores Amarillas',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/cd309af2-66cc-4721-cc51-72039ea2ab00/public',
      path: '/ocasion/flores-amarillas',
      alt: 'Girasoles y flores amarillas Arequipa - Día de la amistad'
    },
    {
      title: 'Cumpleaños',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/2966eecc-e8a1-45fa-66f6-df9656ec7e00/publicContain',
      path: '/ocasion/cumpleanos',
      alt: 'Flores para cumpleaños Arequipa - Arreglos festivos delivery'
    },
    {
      title: 'Día del Padre y Madre',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/0c6ec651-4d5b-41a1-7023-7d76371fd400/public',
      path: '/ocasion/dia-madre-padre',
      alt: 'Flores día de la madre Arequipa - Regalos para mamá'
    }
  ];

  const featured = [
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/33cd1368-94c3-4419-816b-25a0665aad00/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/bb93110a-0b28-4db3-dca0-519eed18e700/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/d68dc67d-a474-411f-7778-01912d216e00/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/ddfe2943-0e5b-4737-47ef-5c0157097800/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/c042e033-28d7-4443-8095-28fbd2b08700/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/7f9b0fda-3a29-46d0-bfc4-0c247e10f200/public'
  ];

  const features = [
    {
      icon: Flower2,
      title: 'Flores Premium',
      description: 'Calidad garantizada'
    },
    {
      icon: Truck,
      title: 'Delivery Express',
      description: 'En menos de 3 horas'
    },
    {
      icon: CreditCard,
      title: 'Pago Fácil',
      description: 'Yape, Plin y tarjetas'
    }
  ];

  return (
    <div className="min-h-screen bg-pink-50 pt-16 md:pt-20">
      <SEO 
        title="Flores y Arreglos Florales en Arequipa"
        description="Florería en Arequipa con delivery express en menos de 3 horas. Ramos de rosas, lirios, girasoles, arreglos florales, peluches y más. ¡Compra flores frescas ahora! Envío el mismo día."
        keywords="floreria arequipa, flores arequipa, ramos de flores arequipa, arreglos florales arequipa, delivery flores arequipa, rosas arequipa, lirios arequipa, girasoles arequipa, peluches arequipa, flores a domicilio arequipa, floreria delivery arequipa, comprar flores arequipa, flores frescas arequipa, flores para regalo arequipa, ramo de rosas arequipa, boxes florales arequipa"
      />
      {/* Hero Section - Carrusel de Imágenes */}
      <section className="relative h-[70vh] md:h-[80vh] overflow-hidden">
        {/* Carousel Images */}
        <div className="absolute inset-0">
          {heroImages.map((image, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                index === currentSlide ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <img 
                src={image}
                alt={`Arreglos florales para el Día de la Madre en Arequipa - Regalos para mamá ${index + 1}`}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-pink-50"></div>
            </div>
          ))}
        </div>

        {/* Carousel Controls */}
        <button
          onClick={prevSlide}
          className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 z-20 bg-white/80 hover:bg-white p-2 md:p-3 rounded-full shadow-lg transition-all duration-300 transform hover:scale-110"
          aria-label="Anterior"
        >
          <ChevronLeft className="w-5 h-5 md:w-6 md:h-6 text-pink-900" />
        </button>
        <button
          onClick={nextSlide}
          className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 z-20 bg-white/80 hover:bg-white p-2 md:p-3 rounded-full shadow-lg transition-all duration-300 transform hover:scale-110"
          aria-label="Siguiente"
        >
          <ChevronRight className="w-5 h-5 md:w-6 md:h-6 text-pink-900" />
        </button>

        {/* Carousel Indicators */}
        <div className="absolute bottom-24 md:bottom-32 left-1/2 -translate-x-1/2 z-20 flex gap-2">
          {heroImages.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-2 h-2 md:w-3 md:h-3 rounded-full transition-all duration-300 ${
                index === currentSlide ? 'bg-white w-6 md:w-8' : 'bg-white/50'
              }`}
              aria-label={`Ir a imagen ${index + 1}`}
            />
          ))}
        </div>
        
        <div className="relative z-10 h-full flex flex-col items-center justify-center px-4 text-center">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-4 md:mb-6 leading-tight drop-shadow-2xl">
            El amor más grande merece <br />
            <span className="text-pink-300">las flores más hermosas</span>
          </h1>
          
          <p className="text-xl md:text-2xl lg:text-3xl text-white mb-3 md:mb-4 font-medium drop-shadow-lg">
            Este Día de la Madre, hazla sentir lo especial que es
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 md:gap-4 text-sm md:text-base text-white mb-6 md:mb-8 drop-shadow-lg">
            <span className="flex items-center gap-2">
              <span className="text-pink-300">✓</span>
              Envío express en menos de 3 horas
            </span>
            <span className="hidden sm:inline">•</span>
            <span className="flex items-center gap-2">
              <span className="text-pink-300">✓</span>
              Arreglos hechos con amor
            </span>
          </div>

          {/* Catálogo Button - Día de la Madre */}
          <div className="mb-6">
            <a
              href="https://drive.google.com/file/d/1zg5O5t4A8fkwVEuTj_xxigogVc3CBFif/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block transform hover:scale-105 transition-all duration-300"
            >
              <img 
                src="https://customer-assets.emergentagent.com/job_d77f3a6b-9965-447f-a586-d0e19241b16e/artifacts/m0oduwl3_image.png"
                alt="Catálogo Día de la Madre 2026 - TQM Florería Arequipa"
                className="h-32 md:h-40 lg:h-48 w-auto rounded-xl shadow-2xl hover:shadow-3xl transition-all duration-300 border-4 border-white/80"
              />
            </a>
            <p className="text-white text-sm md:text-base mt-2 drop-shadow-lg font-semibold">
              👆 Mira nuestro Catálogo especial Día de la Madre
            </p>
          </div>
          
          <Button 
            onClick={() => window.open('https://wa.me/51959389799?text=Hola,%20quiero%20hacer%20un%20pedido', '_blank')}
            className="bg-green-500 hover:bg-green-600 text-white px-6 md:px-10 py-4 md:py-6 text-base md:text-xl rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-105 font-bold"
          >
            <svg className="w-5 h-5 md:w-6 md:h-6 mr-2" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
            </svg>
            Pedir Ahora
          </Button>
        </div>
      </section>

      {/* Featured Gallery */}
      <section className="py-8 md:py-12 px-4">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-center text-pink-900 mb-6 md:mb-8">Nuestros Arreglos Destacados</h2>
        <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
          {featured.map((image, index) => (
            <div 
              key={index}
              onClick={() => handleNavigation('/galeria')}
              className="group overflow-hidden bg-white rounded-xl md:rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 cursor-pointer aspect-square"
            >
              <img 
                src={image}
                alt={`Arreglos florales destacados en Arequipa - Flores frescas delivery express ${index + 1}`}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
              />
            </div>
          ))}
        </div>
        <div className="text-center mt-6 md:mt-8">
          <button
            onClick={() => handleNavigation('/galeria')}
            className="text-pink-600 hover:text-pink-700 font-semibold text-base md:text-lg flex items-center gap-2 mx-auto"
          >
            Ver Galería Completa
            <ArrowRight className="w-5 h-5" />
          </button>
        </div>
      </section>

      {/* Categories Section */}
      <section className="py-8 md:py-12 px-4 bg-white">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-center text-pink-900 mb-6 md:mb-8">Nuestras Categorías</h2>
        <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {categories.map((category, index) => (
            <div 
              key={index}
              onClick={() => handleNavigation(category.path)}
              className="group overflow-hidden bg-pink-50 rounded-xl md:rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 cursor-pointer"
            >
              <div className="aspect-square overflow-hidden">
                <img 
                  src={category.image}
                  alt={category.alt}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
              </div>
              <div className="p-3 md:p-4 text-center">
                <h3 className="text-lg md:text-xl font-bold text-pink-900">{category.name}</h3>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Occasions Section */}
      <section className="py-8 md:py-12 px-4">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-center text-pink-900 mb-6 md:mb-8">Para Cada Ocasión</h2>
        <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {occasions.map((occasion, index) => (
            <div 
              key={index}
              onClick={() => handleNavigation(occasion.path)}
              className="group overflow-hidden bg-white rounded-xl md:rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 cursor-pointer"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img 
                  src={occasion.image}
                  alt={occasion.alt}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-pink-900/80 via-pink-900/40 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4 text-white">
                  <h3 className="text-sm md:text-base lg:text-lg font-bold">{occasion.title}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Features Section */}
      <section className="py-8 md:py-12 px-4 bg-white">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div 
                key={index}
                className="bg-pink-50 rounded-2xl p-6 md:p-8 text-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
              >
                <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-pink-100 rounded-full mb-4">
                  <Icon className="w-8 h-8 md:w-10 md:h-10 text-pink-600" />
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-pink-900 mb-2">{feature.title}</h3>
                <p className="text-pink-700 text-base md:text-lg">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 md:py-16 px-4 bg-gradient-to-b from-pink-100 to-pink-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-pink-900 mb-4 md:mb-6">
            ¿Listo para Sorprender?
          </h2>
          <p className="text-base md:text-lg text-pink-800 mb-6 md:mb-8">
            Contáctanos ahora y recibe tus flores en menos de 3 horas
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => window.open('https://wa.me/51959389799?text=Hola,%20quiero%20hacer%20un%20pedido', '_blank')}
              className="bg-green-500 hover:bg-green-600 text-white px-6 md:px-8 py-3 md:py-4 text-base md:text-lg rounded-full font-semibold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
            >
              <svg className="w-5 h-5 md:w-6 md:h-6 mr-2" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
              </svg>
              Pedir por WhatsApp
            </Button>
            <button
              onClick={() => handleNavigation('/contacto')}
              className="bg-pink-600 hover:bg-pink-700 text-white px-6 md:px-8 py-3 md:py-4 text-base md:text-lg rounded-full font-semibold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
            >
              Ver Información de Contacto
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;